import environmentConfig from './utils/configs';

const appVersion = import.meta.env.VITE_SENTRY_RELEASE || '0.0.0';

const config = {
    EVENT_NAMESPACE: 'beststart-centreservices-web',
    audience: 'beststart-centreservices-web',
    gitBranch: null,
    version: appVersion,
    namespace: 'beststart-centreservices-web',
    tag: 'beststart-centreservices-web',
    env: import.meta.env.MODE,
    centreServiceApiUrl: environmentConfig.centreServiceApiUrl,
    LogLevel: environmentConfig.LogLevel || 0,
    sampleRate: environmentConfig.sampleRate || 0,
    sentry: environmentConfig.sentry || null,
    authentication: {
        clientId: environmentConfig.clientId,
        authority: environmentConfig.authority,
        authBaseUrl: environmentConfig.centreServiceApiUrl,
        redirectUri: window.location.hostname === "localhost.lambdatest.com"
            ? 'https://localhost.lambdatest.com:50329/login'
            : `${window.location.origin}/login`,
    },
};

if (config.authentication.clientId?.startsWith('REPLACE_WITH_')) {
    console.error('[config] Production clientId has not been set — authentication will fail.');
}

export default config;
